import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * Accessible Breadcrumb navigation component
 * Follows WAI-ARIA breadcrumb pattern for screen readers
 * 
 * @param {Object[]} items - Array of breadcrumb items
 * @param {string} items[].label - Display text
 * @param {string} items[].href - Link URL (optional for last item)
 * @param {string} className - Additional classes for nav wrapper
 * @param {string} linkClassName - Classes for links
 * @param {string} separatorClassName - Classes for separator
 */
const Breadcrumb = ({ 
  items, 
  className = '', 
  linkClassName = 'hover:text-white transition-colors',
  separatorClassName = 'mx-2 opacity-60',
  currentClassName = ''
}) => {
  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex items-center flex-wrap gap-1 text-sm" role="list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight 
                  size={14} 
                  className={separatorClassName} 
                  aria-hidden="true" 
                />
              )}
              {isLast ? (
                <span 
                  aria-current="page" 
                  className={currentClassName}
                >
                  {item.label}
                </span>
              ) : (
                <Link 
                  to={item.href} 
                  className={linkClassName}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
